import ButtonInstance from "../components/ButtonInstance";
import "./Chat.css";
import { useEffect, useRef, useState } from "react";
import ChatAssistantDropDown2 from "./ChatAssistantDropdown2";
import MessageText from "../components/MessageText";
import UserModel from "../models/userModel";
import User from "../models/user";
import Assistant from "../models/assistantModel";
// eslint-disable-next-line no-unused-vars
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import EmailActionNavigationBreadCrumbs from "../components/EmailActionNavigationBreadCrumbs";

import { v4 as uuidv4 } from "uuid";
import ChatHistoryDropdown from "../components/ChatHistoryDropdown";
import { compareGuidelinesLoadingStatements } from "../helpers/loadingStatements";
import BackgroundSearch from "./BackgroundSearch";
import sampleHtml from "./sampleHtml";
import InjectHTML from "../components/InjectHTML";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Drawer, Button, Box } from "@mui/material";
import RequireUpgradeModal from "../components/RequireUpgradeModal";

import VoiceChat from "./VoiceChat";
import { useOrganization } from "../contexts/OrganizationContext";
// eslint-disable-next-line no-undef
const hostName = window.location.host;

const Chat = () => {
  // Get URL search params, uid, email, token, name.
  // eslint-disable-next-line no-undef
  const urlParams = new URLSearchParams(window.location.search);

  const uid = urlParams.get("uid");
  const organizationId = urlParams.get("organizationId");
  const email = urlParams.get("email");
  const token = urlParams.get("token");
  const name = urlParams.get("name") || "You";
  const clientID = urlParams.get("clientID");
  const selectedAssistantID = urlParams.get("selectedAssistantID");
  const clientHostname = urlParams.get("clientHostname") || hostName;
  const data = urlParams.get("data") ? JSON.parse(urlParams.get("data")) : {};
  const defaultSelectedAssistant = urlParams.get("assistant");
  const urlOverlayMode = urlParams.get("overlayMode");
  const restoreLastChat = urlParams.get("restoreLastChat");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 768);
  const [compareMode, setCompareMode] = useState(false);
  const [overlayMode, setOverlayMode] = useState(
    urlOverlayMode && urlOverlayMode === "true"
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);
  const [recording, setRecording] = useState(false);
  const [voiceMode, setVoiceMode] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const isCompareMode = urlParams.get("compareMode");
  const [isAllowedCompareMode, setIsAllowedCompareMode] = useState(
    isCompareMode || "false"
  );
  const isVoiceMode = urlParams.get("voiceMode");
  const [isAllowedVoiceMode, setIsAllowedVoiceMode] = useState(
    isVoiceMode || "false"
  );
  const [showUpgrade, setShowUpgrade] = useState(false);

  useEffect(() => {
    if (uid) {
      getUserData(uid);
    }
  }, [uid]);

  const getUserData = async (uid) => {
    const organizations = await User.getUserOrganizations(uid);
    // console.log("organizations", organizations);
    if (organizations?.length) {
      // check if any of the organizations have a subscription that is active
      const subscription = organizations.some(
        (org) => org.subscription && org.subscription.status === "active"
      );
      if (!subscription) {
        setIsAllowedCompareMode("false");
        setIsAllowedVoiceMode("false");
      } else {
        setIsAllowedCompareMode("true");
        setIsAllowedVoiceMode("true");
      }
    }
  };

  const isInIframe = (() => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  })();

  const startRecording = async () => {
    if (isAllowedVoiceMode === "true") {
      setVoiceMode(true);
    } else {
      if (!isInIframe) {
        //setVoiceMode(true);
        setShowUpgrade(true);
      } else {
        window?.parent?.postMessage("upgradeRequired", "*");
      }
    }
  };

  const onCompareModeChange = (mode) => {
    if (isAllowedCompareMode === "true") {
      setCompareMode(mode ?? false);
    } else {
      if (!isInIframe) {
        setShowUpgrade(true);
      } else {
        window?.parent?.postMessage("upgradeRequired", "*");
      }
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop(); // triggers ondataavailable and onstop
    setRecording(false);
  };

  let hideHotTip = urlParams.get("hideHotTip") || "false";
  hideHotTip = hideHotTip === "true";

  let alignInputBottom = urlParams.get("alignInputBottom") || "false";
  alignInputBottom = alignInputBottom === "true";

  let showOnboarding = urlParams.get("showOnboarding");

  // eslint-disable-next-line no-undef
  if (
    sessionStorage.getItem("onboardingHasBeenShown") === null &&
    showOnboarding === "true"
  ) {
    // eslint-disable-next-line no-undef
    sessionStorage.setItem("onboardingHasBeenShown", "true");
  } else {
    showOnboarding = "false";
  }

  // Initialize a new user model
  const user = new UserModel(uid, token, email, clientHostname, organizationId);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showChatHistory, setShowChatHistory] = useState(false);
  const [chatHistoryReferencedElementId, setChatHistoryReferencedElementId] =
    useState(null);
  const [referecedElementId, setReferencedElementId] = useState(null);
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [defaultAssistant, setDefaultAssistant] = useState(null);
  const [currentView, setCurrentView] = useState("select-assistant");
  const [messageTexts, setMessageTexts] = useState([]);
  const [CHAT_ID, setChatID] = useState(uuidv4());
  const [selectedChatHistory, setSelectedChatHistory] = useState(null);

  const formatChatName = clientHostname
    ? clientHostname.replace("www.", "")
    : getDateFormat();
  const [chatName, setChatName] = useState(formatChatName);

  const [tooltipRun, setTooltipRun] = useState(showOnboarding === "true");
  const [tooltipSteps, setTooltipSteps] = useState([]);
  const [currentlyTyping, setCurrentlyTyping] = useState(false);
  const [documentsContext, setDocumentsContext] = useState([]);
  const [documentsComparedContext, setDocumentsComparedContext] = useState([]);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [files, setFiles] = useState([]);
  const [usedFiles, setUsedFiles] = useState([]);
  const { selectedOrganizationId } = useOrganization();

  // State for handling document requests
  const [emailThread, setEmailThread] = useState(null);
  const [documents, setDocuments] = useState(null);
  let generateRequestEmailForDocument = false;

  // const [currentMessage, setCurrentMessage] = useState(null);

  // Ref for dropdown wrapper
  const dropdownRef = useRef(null);
  const assistantTopSelectRef = useRef(null);
  const chatHistoryInfoRef = useRef(null);
  const bigAssistantsDropdownRef = useRef(null);
  const chatHistoryRef = useRef(null);
  const chatNameDropdownRef = useRef(null);

  // Event handler for click events
  const handleClickOutside = (event) => {
    // If user clicks outside or inside of dropdown ref
    // Close the dropdown
    if (
      (bigAssistantsDropdownRef.current &&
        !bigAssistantsDropdownRef.current.contains(event.target)) ||
      (dropdownRef.current && !dropdownRef.current.contains(event.target))
    ) {
      setShowDropdown(false);
      if (
        !(
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target) &&
          assistantTopSelectRef.current &&
          !assistantTopSelectRef.current.contains(event.target)
        )
      ) {
        setShowDropdown(true);
      }
    }
  };

  // Event handler for click events
  const handleClickOutsideChatHistoryDropdown = (event) => {
    // If user clicks outside or inside of dropdown ref
    // Close the dropdown
    if (
      chatNameDropdownRef.current &&
      !chatNameDropdownRef.current.contains(event.target)
    ) {
      setShowChatHistory(false);
      if (
        !(
          chatNameDropdownRef.current &&
          !chatNameDropdownRef.current.contains(event.target) &&
          chatHistoryInfoRef.current &&
          !chatHistoryInfoRef.current.contains(event.target)
        )
      ) {
        setShowChatHistory(true);
      }
    }
  };

  const bigAssistantChangeClick = () => {
    setReferencedElementId("addy-big-assistant-select");
    setShowDropdown(true);
    // Show
  };

  const onShowChatHistoryClick = () => {
    setChatHistoryReferencedElementId("addy-chat-history-select");
    setShowChatHistory(true);
  };

  useEffect(() => {
    setTooltipSteps([
      {
        target: ".tooltip-1",
        title: "Private and Secure Chat",
        content: "All chats are private, secure, and only available to you.",
        disableBeacon: true,
      },
      {
        target: ".tooltip-2",
        title: "Choose Assistant or Create New",
        content:
          "Select an assistant to chat with or create a new one. Each assistant can be trained on different data.",
      },
      {
        target: ".tooltip-3",
        title: "Manage Assistants or Close Chat",
        content:
          "Click the expand icon to open the portal. Here you can create and train custom AI assistants for your company. Close the chat by clicking the close icon.",
      },
      {
        target: ".tooltip-4",
        title: "Highlight Any Text on Your Web Page",
        content:
          "Press and hold the Control key, then highlight text on any web page. Your assistant can provide you with relevant information like a summary, explanation, or answer to questions about the text.",
      },
      {
        target: ".tooltip-5",
        title: "Suggested Prompts",
        content:
          "Need help getting started? Click on one of these prompt to start a conversation with your assistant.",
      },
      {
        target: ".tooltip-6",
        title: "Ask Your Assistant Anything",
        content:
          "Type your question or message here and click the send button to chat with your assistant.",
      },
    ]);
  }, []);

  // Add event listener for clicks on the document
  useEffect(() => {
    // Initialize window post message listener
    windowListenForPostMessage();

    // eslint-disable-next-line no-undef
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("click", handleClickOutsideChatHistoryDropdown);
    // Set assistants
    user.getAssistants().then((assistants) => {
      setAssistants(assistants);
      if (assistants.length && !selectedAssistant) {
        // Set the first assistant as the selected assistant
        if (defaultSelectedAssistant) {
          let defaultAssistant = assistants.find(
            (assistant) => assistant.appID === defaultSelectedAssistant
          );
          if (defaultAssistant) {
            setSelectedAssistant(defaultAssistant);
          } else {
            defaultAssistant = assistants.find(
              (assistant) => assistant.defaultId === defaultSelectedAssistant
            );
            if (defaultAssistant) {
              setSelectedAssistant(defaultAssistant);
            } else {
              setSelectedAssistant(assistants[0]);
            }
          }
        } else {
          setSelectedAssistant(assistants[0]);
        }
      }
      if (assistants.length && selectedAssistantID) {
        // Set the selected assistant
        const assistant = assistants.find(
          (assistant) => assistant.appID === selectedAssistantID
        );
        setSelectedAssistant(assistant);
      }
      if (
        assistants.length &&
        !defaultSelectedAssistant &&
        !selectedAssistantID
      ) {
        // If no assistant was supplied in the URL params, get it from backend
        // Initialize the default assistant from backend
        initializeDefaultAssistant(assistants);
      }
    });

    // Scroll to the bottom of the chat
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }

    // Clean up by removing the event listener on unmount
    return () => {
      // eslint-disable-next-line no-undef
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener(
        "click",
        handleClickOutsideChatHistoryDropdown
      );
      // Remove window message event listener
      window.removeEventListener("message", handlePostMessage);
    };
  }, []);

  // For drawer open and close
  useEffect(() => {
    const handleResize = () => {
      const wideScreen = window.innerWidth >= 768;
      setIsWideScreen(wideScreen);

      // Automatically close the drawer if switching to a small screen
      if (!wideScreen) {
        setIsDrawerOpen(false);
      } else {
        setIsDrawerOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   if (chatHistoryRef.current) {
  //     chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
  //   }
  //   console.log("Selected assistant in use effect", selectedAssistant);
  // }, [messageTexts, selectedAssistant]);

  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTo({
        top: chatHistoryRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
    const addyChatHistoryEl = document.getElementById("addy-chat-history");
    if (overlayMode && addyChatHistoryEl) {
      // Scroll to the bottom
      addyChatHistoryEl.scrollTo({
        top: addyChatHistoryEl.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messageTexts, selectedAssistant]);

  // Auto-save chat when messageTexts changes
  useEffect(() => {
    if (messageTexts.length > 0) {
      saveCurrentChatLocally();
    }
  }, [messageTexts]);

  // Auto-restore last chat when assistants are loaded
  useEffect(() => {
    if (restoreLastChat === "true") {
      autoRestoreLastChat();
    }
  }, [restoreLastChat]);

  const playVoiceResponseSequential = (() => {
    let lastPromise = Promise.resolve();

    return (text) => {
      lastPromise = lastPromise.then(
        () =>
          new Promise((resolve, reject) => {
            playVoiceResponse(text)
              .then((audioElement) => {
                audioElement.onended = resolve;
                audioElement.onerror = reject;
              })
              .catch(reject);
          })
      );
      return lastPromise;
    };
  })();

  const onSendButtonClick = async (
    prompt,
    selectedText,
    compareMode,
    files,
    isVoiceMode = false,
    playVoiceResponse = null
  ) => {
    if (!prompt || prompt === "" || prompt.trim === "") {
      // eslint-disable-next-line no-undef
      alert("Prompt cannot be empty");
      return;
    }
    // Change the view to chat to show the chat messages
    if (currentView === "select-assistant") setCurrentView("chat");

    // Append the user's message to the chat
    const userMessageId = uuidv4();
    const userMessageText = userMessage(prompt, selectedText, userMessageId);
    setMessageTexts((prevMessageTexts) => [
      ...prevMessageTexts,
      userMessageText,
    ]);
    // Create Thinking Text and append to messageTexts
    const assistantMessageId = uuidv4();
    const assistantMessageTextBuffer = assistantMessage(
      "",
      "thinking",
      assistantMessageId
    );
    setMessageTexts((prevMessageTexts) => [
      ...prevMessageTexts,
      assistantMessageTextBuffer,
    ]);

    // Get the assistant's response
    // console.log("Selected assistant", selectedAssistant);

    let requestParams = {
      language: "english",
      tone: "neutral",
      name: name,
      user_prompt: prompt,
      selected_text: selectedText,
      isComparison: compareMode,
    };

    if (files && files.length && files.length > 0) {
      // map files and usedFiles to the request params (uasedfiles that have different file names)
      if (usedFiles && usedFiles.length > 0) {
        // Flatten all files from all objects in the usedFiles array
        const allUsedFiles = usedFiles.flatMap((obj) => obj.files || []);

        const usedFilesWithDifferentNames = allUsedFiles.filter(
          (usedFile) => !files.some((file) => file.name === usedFile.name)
        );

        requestParams.attachmentListBase64 = [
          ...files.map((file) => ({
            name: file.name,
            textContent: file.textContent,
          })),
          ...usedFilesWithDifferentNames.map((file) => ({
            name: file.name,
            textContent: file.textContent,
          })),
        ];
      } else {
        requestParams.attachmentListBase64 = files.map((file) => ({
          name: file.name,
          textContent: file.textContent,
        }));
      }

      setUsedFiles((prevUsedFiles) => [
        ...prevUsedFiles,
        {
          files: files,
          messageId: userMessageId,
        },
      ]);
    } else {
      if (usedFiles && usedFiles.length && usedFiles.length > 0) {
        requestParams.attachmentListBase64 = usedFiles.flatMap((obj) =>
          obj.files.map((file) => ({
            name: file.name,
            textContent: file.textContent,
          }))
        );
      }
    }

    // put on the used files and relate it to the current message id

    setFiles([]);

    setLoadingDocuments(true);
    const responses = await Assistant.getEmailReplyChat(
      selectedOrganizationId || null,
      selectedAssistant?.appID,
      selectedAssistant?.publicId,
      uid,
      hostName,
      CHAT_ID,
      prompt,
      selectedText,
      name,
      clientHostname,
      selectedChatHistory,
      requestParams,
      email,
      selectedAssistant?.publicId === "1123cacb-2789-4531-936c-8c9b8c94b647"
        ? "addy-assistant-001"
        : "addy-assistant-001",
      [],
      [],
      true,
      messageTexts.map((msg) => ({
        message: msg.message,
        name: msg.name,
      })),
      voiceMode // Pass the voiceMode state
    );

    // const responses = await Assistant.sendMessage(
    //   selectedAssistant?.appID,
    //   selectedAssistant?.publicId,
    //   uid,
    //   hostName,
    //   CHAT_ID,
    //   prompt,
    //   selectedText,
    //   name,
    //   clientHostname,
    //   selectedChatHistory
    // );

    // Get the last assistant message which was thinking
    let assistantMessageElement = document.getElementById(
      `${assistantMessageId}`
    );
    if (!assistantMessageElement) {
      await sleep(10); // wait for the assistant message to render
      assistantMessageElement = document.getElementById(
        `${assistantMessageId}`
      );
      if (!assistantMessageElement) {
        console.error(
          "Assistant message element not found after waiting",
          assistantMessageId
        );
        return;
      }
    }

    // Type in the assistant's response
    const messageText = assistantMessageElement?.querySelector(
      ".model-response-text"
    );
    const feedbackContainer = assistantMessageElement?.querySelector(
      ".feedback-container"
    );
    let firstChunk = true;
    // Set currently typing to be true
    setCurrentlyTyping(true);
    let fullResponse = "";
    let buffer = "";

    try {
      for await (const response of responses) {
        let text = "";
        let textWithoutMardown = "";
        if (typeof response === "string") {
          if (response.includes("documents-fetched-")) {
            const documents = JSON.parse(
              response.split("documents-fetched-")[1]
            );
            const docObj = {
              documents: documents,
              messageId: messageTexts.length + 1,
            };
            // console.log("Documents fetched", docObj);
            setDocumentsContext([...documentsContext, docObj]);
            text = "";
          } else if (response.includes("documents-compared-")) {
            // console.log("Documents compared", response);
            const documents = JSON.parse(
              response.split("documents-compared-")[1]
            );
            const docObj = {
              documentsCompared: documents,
              messageId: messageTexts.length + 1,
            };
            // console.log("Documents compared", docObj);
            setDocumentsComparedContext([...documentsComparedContext, docObj]);
            text = "";
          } else {
            if (
              response &&
              typeof response === "string" &&
              response.split("data: ") &&
              response.split("data: ").length > 1
            ) {
              text = response.split("data: ")[1];
            } else {
              text = response;
            }
            textWithoutMardown = text
              .replace(/(\*\*|\*|`|#+|>|\[|\]|\(|\)|~|_|-)/g, "")
              .replace(
                /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g,
                ""
              );
          }
        } else {
          // console.error("Response is not a string:", response);
          continue; // Skip the current iteration as response isn't a string.
        } // Produce a typing effect for the text

        // if(response && typeof response === "string" && response.split("data: ") && response.split("data: ").length > 1) {
        //   text = response.split("data: ")[1];
        // } else {
        //   text = response;
        // }
        // Produce a typing effect for the text
        if (firstChunk) {
          // Remove the loading part of the thinking element
          const thinkingElement =
            assistantMessageElement?.querySelector(".dot");
          if (thinkingElement) thinkingElement.remove();

          const thinkingText =
            assistantMessageElement?.querySelector(".thinking-text");
          if (thinkingText) thinkingText.remove();

          // Make the message text visible
          messageText.classList.remove("hide");
          firstChunk = false;
        }

        let chunkSize = 50;

        for (let i = 0; i < text.length; i += chunkSize) {
          const newChunk = text.substring(i, i + chunkSize);
          fullResponse += newChunk;

          setMessageTexts((prevMessageTexts) => {
            const newMessageTexts = [...prevMessageTexts];

            // Append new chunk to the last message's existing text
            newMessageTexts[newMessageTexts.length - 1].message += newChunk;

            return newMessageTexts;
          });

          //await sleep(2); // Adjust this for speed control
        }

        // Replace with this improved code:
        if (voiceMode) {
          // Clean markdown and special characters
          buffer += textWithoutMardown;

          // Match all full sentences in the buffer
          const sentenceEndRegex = /[^.?!]*[.?!]/g;
          let match;
          let lastCompleteIndex = 0;
          let sentencesToSpeak = [];

          // Extract all sentences
          while ((match = sentenceEndRegex.exec(buffer)) !== null) {
            const sentence = match[0].trim();
            if (sentence.length > 0) {
              sentencesToSpeak.push(sentence);
              lastCompleteIndex = sentenceEndRegex.lastIndex;
            }
          }

          // Group short sentences if needed
          const processedSentences = [];
          let currentGroup = "";

          for (const sentence of sentencesToSpeak) {
            if (currentGroup.length + sentence.length < 100) {
              currentGroup += (currentGroup ? " " : "") + sentence;
            } else {
              if (currentGroup) processedSentences.push(currentGroup);
              currentGroup = sentence;
            }
          }
          if (currentGroup) processedSentences.push(currentGroup);

          // Speak each processed sentence
          for (const sentence of processedSentences) {
            try {
              await playVoiceResponse(sentence);
            } catch (error) {
              if (error.message === "Audio playback error.") {
                // Audio was stopped, continue with the next sentence
                continue;
              }
              throw error; // Re-throw other errors
            }
          }

          // Keep the remainder (incomplete sentence) in the buffer
          buffer = buffer.slice(lastCompleteIndex);
        }

        // Create a typing effect
        //for (let i = 0; i < text.length; i++) {
        // Append messageText message attribute to text at character i
        //setMessageTexts((prevMessageTexts) => {
        //const newMessageTexts = [...prevMessageTexts];
        //newMessageTexts[newMessageTexts.length - 1].message += text.charAt(i);
        //return newMessageTexts;
        //});

        //await sleep(5); // Sleep for 5 milliseconds to create typing effect
        // Scroll to the bottom of the chat
        //if (chatHistoryRef.current) {
        //chatHistoryRef.current.scrollTop =
        //chatHistoryRef.current.scrollHeight;
        // }
        //}
      }
      setLoadingDocuments(false);

      if (voiceMode && buffer.trim().length > 0) {
        try {
          await playVoiceResponse(buffer.trim());
        } catch (error) {
          if (error.message !== "Audio playback error.") {
            throw error;
          }
        }
      }
    } catch (error) {
      console.error("Error processing reduceResult:", error);
      setLoadingDocuments(false);
      setCurrentlyTyping(false);
    }
    // Set currently typing to be false
    setCurrentlyTyping(false);
    feedbackContainer.classList.remove("hide");
    // Chat will be auto-saved by useEffect when messageTexts updates
    //return fullMessageText;
    return fullResponse;
  };

  const saveCurrentChatLocally = () => {
    if (messageTexts.length && selectedAssistant?.appID) {
      const locallyStoredChat = {
        chatID: CHAT_ID,
        messages: messageTexts,
        appID: selectedAssistant.appID,
        publicId: selectedAssistant?.publicId,
        chatName: chatName,
      };
      localStorage.setItem(CHAT_ID, JSON.stringify(locallyStoredChat));
      // Save a map of the save chats and their local storage keys
      const savedChats =
        JSON.parse(localStorage.getItem("addy-ai-sidebar-chats")) || {};
      if (!savedChats[CHAT_ID]) {
        savedChats[CHAT_ID] = {
          chatName: chatName,
          chatID: CHAT_ID,
          clientHostname: clientHostname,
          publicId: selectedAssistant?.publicId,
          appID: selectedAssistant.appID,
          dateStarted: Date.now(), // Epoch time in milliseconds
          lastActive: Date.now(), // Epoch time in milliseconds
        };
        localStorage.setItem(
          "addy-ai-sidebar-chats",
          JSON.stringify(savedChats)
        );
      } else {
        // Chat exists, update the last active time
        savedChats[CHAT_ID].lastActive = Date.now();
        localStorage.setItem(
          "addy-ai-sidebar-chats",
          JSON.stringify(savedChats)
        );
      }

      // Save the current chat as the last active chat
      localStorage.setItem("addy-ai-sidebar-last-chat-id", CHAT_ID);
    }
  };

  async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const onAssistantClick = (assistant) => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('assistant', assistant.defaultId ? assistant.defaultId : assistant.appID);
    setSearchParams(currentParams);
    setSelectedAssistant(assistant);
    setShowDropdown(false);
  };

  const userMessage = (message, selectedText, messageId) => {
    return {
      message: message,
      selectedText: selectedText,
      name: name,
      type: "user",
      messageId: messageId,
      imageURL: "https://i.imgur.com/W1yNbq7.png",
    };
  };

  const assistantMessage = (message, action, messageId) => {
    return {
      message: message,
      name: selectedAssistant?.appName || "Addy AI",
      type: "assistant",
      messageId: messageId,
      action: action || "none",
      imageURL: selectedAssistant?.imageUrl || "/assistant-icon.svg",
    };
  };

  const initializeDefaultAssistant = (assistants) => {
    user.getDefaultAssistant().then((id) => {
      // Get the default assistant from backend if available, or else use Addy AI as default
      const defaultAssistantId = id;
      const defaultAssistant = assistants.find(
        (assistant) => assistant.appID === defaultAssistantId
      );
      if (defaultAssistant) {
        // Set default assistant on frontened
        setDefaultAssistant(defaultAssistant);
        setSelectedAssistant(defaultAssistant);
      } else if (assistants.length) {
        // Set default assistant on frontened
        setDefaultAssistant(assistants[0]);
        setSelectedAssistant(assistants[0]);
      }
    });
  };

  const updateDefaultAssistant = (assistant, e) => {
    // Click event did not come form the item
    if (!e) return;
    // Set the default assistant in the frontend and backend
    setDefaultAssistant(assistant);
    // Set the selected assistant (observe this ux. users may want to change the default assistant without changing the selected assistant)
    setSelectedAssistant(assistant);
    user.setDefaultAssistant(assistant.appID).then((success) => {
      if (success) {
        toastify("Default assistant updated successfully", true);
      } else {
        toastify("Failed to update default assistant", false);
      }
    });
    // eslint-disable-next-line max-len
    // if (assistant.appID !== "addy-default-assistant-c66e0609-371e-49b2-bb4a-5186526b2a9d") {
    //     // Update the default assistant in the backend
    //     user.setDefaultAssistant(assistant.appID);
    // }
  };

  const getDateFormat = () => {
    const date = Date.now();
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(date).toLocaleDateString("en-US", options);
  };

  const handlePostMessage = (event) => {
    const origin = event.origin || event.originalEvent.origin;
    // console.log("Origin", origin);

    const data = event.data;
    // console.log("Data received from window post message", data);
    if (data && data.key) {
      const action = data.key;
      const value = data.value;
      switch (action) {
        case "emailThread":
          setEmailThread(value);
          break;
        case "document":
          setDocuments(value);
          break;
        case "documentToRequest":
          generateRequestEmailForDocument = true;
          if (value && value.category) {
            const prompt =
              "Write an email to " +
              (value?.recipientInfo
                ? value?.recipientInfo
                : "{{recipient_Name}}") +
              " requesting the following missing loan documents: -.-." +
              value.category;
            // Trigger the chat with the document request prompt
            onSendButtonClick(prompt, "", false, []);
          }
          break;
        case "attachmentListBase64":
          // Handle attachment data if needed
          if (value && value.length) {
            // Convert attachments to files format expected by Chat component
            const attachmentFiles = value.map((attachment) => ({
              name: attachment.name || "attachment",
              textContent: attachment.textContent || attachment.content || "",
            }));
            setFiles((prev) => [...prev, ...attachmentFiles]);
          }
          break;
        default:
          break;
      }
    }
  };

  const windowListenForPostMessage = () => {
    window.addEventListener("message", handlePostMessage);
    if (parent) {
      parent.postMessage("addy-iframe-loaded", "*");
    }
  };

  const handleJoyrideCallback = (data) => {
    // eslint-disable-next-line no-unused-vars
    const { status, type } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false
      // so we can restart if we click start again.
      setTooltipRun(false);
    }
  };

  const toastify = (message, success, yellowWarning = false) => {
    if (success) {
      toast.success(message, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      if (yellowWarning) {
        toast.warning(message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  };

  const onCreateNewChatClick = () => {
    // Create a new chat
    // setChatID(uuidv4());
    // setMessageTexts([]);
    // setChatName(getDateFormat());
    // setCurrentView("select-assistant");
    // setShowChatHistory(false);
    // setShowDropdown(false);
    // For now just refresh the page
    // If restore last chat param is in url remove that param before reloading
    // to start a fresh chat
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete("restoreLastChat");
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
    window.location.reload();
  };

  const autoRestoreLastChat = () => {
    const lastChatId = localStorage.getItem("addy-ai-sidebar-last-chat-id");
    if (!lastChatId || lastChatId === CHAT_ID) return;

    const lastChatData = JSON.parse(localStorage.getItem(lastChatId));
    if (
      !lastChatData ||
      !lastChatData.messages ||
      lastChatData.messages.length === 0
    ) {
      return; // No valid chat to restore
    }

    // Restore the last chat
    onChatTitleClickInChatHistoryDropdown(lastChatId);
  };

  const onChatTitleClickInChatHistoryDropdown = (chatID) => {
    if (chatID === CHAT_ID) {
      setCurrentView("chat");
      setShowChatHistory(false);
      setShowDropdown(false);
      return;
    }
    // console.log("Chat ID", chatID);
    const chatMessages = JSON.parse(localStorage.getItem(chatID));
    const chatMessageTexts = chatMessages.messages;
    if (chatMessages && chatMessageTexts) {
      // Update the chat id
      setChatID(chatID);
      setSelectedChatHistory(chatMessages);
      // Updating assistant messages to replace the thinking "action"
      // with "response" if there's a message with
      // length > 0 in the assistant messages
      for (let i = 0; i < chatMessageTexts.length; i++) {
        if (
          chatMessageTexts[i].type === "assistant" &&
          chatMessageTexts[i].message.length > 0
        ) {
          chatMessageTexts[i].action = "response";
        }
      }
      setMessageTexts(chatMessageTexts);
      setChatName(chatMessages.chatName ? chatMessages.chatName : "Chat");
      // Set the selected assistant
      const assistant = assistants.find(
        (assistant) => assistant.appID === chatMessages.appID
      );
      setSelectedAssistant(assistant);
      // Set the current view to chat
      setCurrentView("chat");
      setShowChatHistory(false);
      setShowDropdown(false);
      // Scroll to the bottom of the chat
      if (chatHistoryRef.current) {
        chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
      }
    }
  };

  return (
    <Box className="chat-page-parent">
      {/* Drawer */}
      <Drawer
        variant={isWideScreen ? "persistent" : "temporary"}
        open={isDrawerOpen}
        onClose={toggleDrawer}
        style={{
          display: overlayMode ? "none" : "block",
        }}
      >
        <Box width={240} role="presentation">
          <div>
            <ChatHistoryDropdown
              displayPosition="bottom"
              referencedElementId={chatHistoryReferencedElementId}
              onCreateNewChatClick={onCreateNewChatClick}
              onChatTitleClick={onChatTitleClickInChatHistoryDropdown}
              ref={chatNameDropdownRef}
              toggleDrawer={toggleDrawer}
            />
          </div>
        </Box>
      </Drawer>

      {/*Page Content*/}

      <div
        className="chat"
        style={{
          flexGrow: 1,
          paddingTop: "25px",
          marginLeft: overlayMode
            ? "0"
            : isWideScreen && isDrawerOpen
            ? "240px"
            : "0",
          background: overlayMode ? "transparent" : "#FFFFFF",
        }}
      >
        <Joyride
          callback={handleJoyrideCallback}
          continuous
          run={tooltipRun}
          scrollToFirstStep
          showProgress
          steps={tooltipSteps}
          styles={{
            options: {
              // this styles the overlay color
              overlayColor: "rgba(0, 0, 0, 0.4)",
              primaryColor: "#7150e0",
            },
          }}
        />

        <section
          ref={chatHistoryRef}
          className={`top addy-custom-scroll ${
            overlayMode ? "overlay-mode-chat-history" : ""
          }`}
          style={{
            position: "relative",
          }}
        >
          {currentView === "chat" && messageTexts?.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: 40,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: 20,
                  background: overlayMode ? "transparent" : "#EFF1F6",
                  padding: "5px 15px",
                  zIndex: 3,
                }}
              >
                <EmailActionNavigationBreadCrumbs
                  overlayMode={overlayMode}
                  currentEmailAction={"Chat"}
                  breadCrumbsHomeClick={() => {
                    setMessageTexts([]);
                  }}
                />
              </div>
            </div>
          )}

          <div
            className={overlayMode ? "overlay-mode-chat-history" : ""}
            style={
              overlayMode
                ? {
                    paddingBottom: 160,
                  }
                : {}
            }
          >
            <div
              id="chat-history-parent"
              className={`chat-message`}
              style={
                overlayMode
                  ? {
                      paddingTop: 40,
                      overflow: "hidden",
                    }
                  : {
                      paddingTop: 40,
                    }
              }
            >
              {overlayMode && messageTexts.length > 0 && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "22px",
                    paddingRight: "6px",
                  }}
                >
                  <div>
                    {/* New chat button */}
                    {messageTexts.length > 0 && <div className="new-chat-button" onClick={() => {
                      onCreateNewChatClick();
                    }}>
                      New chat &nbsp;&nbsp;+
                    </div>}
                  </div>

                  <div
                    style={{
                      background: "#FFFFFF",
                      padding: "10px",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => {
                        window?.parent?.postMessage("close-sidebar", "*");
                      }}
                    >
                      <CloseIcon
                        sx={{
                          fontSize: "14px",
                        }}
                      />
                    </IconButton>
                  </div>
                </div>
              )}
              {currentView == "chat" && (
                <div
                  id="addy-chat-history"
                  className="text-field"
                  style={
                    overlayMode
                      ? {
                          height: "100%",
                          paddingLeft: "0px",
                          paddingRight: "0px",
                          paddingBottom: "50px",
                        }
                      : {}
                  }
                >
                  {messageTexts.map((item, index) => {
                    return (
                      <MessageText
                        overlayMode={overlayMode}
                        usedFiles={usedFiles.filter(
                          (file) => file.messageId === item.messageId
                        )}
                        documents={
                          documentsContext.filter(
                            (doc) => doc.messageId === index
                          )[0]?.documents
                        }
                        documentsCompared={
                          documentsComparedContext.filter(
                            (doc) => doc.messageId === index
                          )[0]?.documentsCompared
                        }
                        loadingDocuments={loadingDocuments}
                        message={item}
                        key={item.messageId || uuidv4()}
                        clientID={clientID}
                        isFirstMessage={index == 0}
                        isLastMessage={index == messageTexts.length - 1}
                        thinkingStatements={
                          compareMode
                            ? compareGuidelinesLoadingStatements
                            : null
                        }
                        compareMode={compareMode}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </section>
        
        {/* Close button for overlay mode when 0 messages */}
        {overlayMode && messageTexts.length === 0 && (
          <div
            style={{
              position: "absolute",
              top: "20px",
            //   bottom: "80%",
              right: "20px",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "#FFFFFF",
                padding: "10px",
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <IconButton
                size="small"
                onClick={() => {
                  window?.parent?.postMessage("close-sidebar", "*");
                }}
              >
                <CloseIcon
                  sx={{
                    fontSize: "14px",
                  }}
                />
              </IconButton>
            </div>
          </div>
        )}
        
        <ButtonInstance
          overlayMode={overlayMode}
          startRecording={startRecording}
          stopRecording={stopRecording}
          recording={recording}
          toastify={toastify}
          files={files}
          setFiles={setFiles}
          usedFiles={usedFiles}
          setUsedFiles={setUsedFiles}
          alignInputBottom={alignInputBottom || false}
          hideHotTipContainer={hideHotTip || true}
          data={data}
          clientID={clientID}
          maxCharsPerLine={30}
          uid={uid}
          currentlyTyping={currentlyTyping}
          hideSuggestedPrompts={messageTexts.length > 0 ? true : false}
          numberOfMessagesInChat={messageTexts.length}
          onClick={(
            prompt,
            selectedText,
            compareModeT,
            isItComparison,
            files
          ) => {
            onSendButtonClick(prompt, selectedText, compareModeT, files);
          }}
          selectedAssistant={selectedAssistant}
          assistants={assistants}
          defaultAssistant={defaultAssistant}
          onAssistantClick={onAssistantClick}
          updateDefaultAssistant={updateDefaultAssistant}
          currentView={currentView}
          isDocumentChat={false}
          clientHostname={clientHostname}
          compareMode={compareMode}
          onCompareModeChange={onCompareModeChange}
          hideFeedbackRequestText={
            clientHostname !== "app.addy.so" &&
            clientHostname !== "devmail.addy.so"
              ? true
              : false
          }
          animatedPlaceholders={true}
        />
        <header
          className="top-bar-new-message"
          style={
            overlayMode
              ? {
                  padding: "16px",
                  display: "none",
                }
              : {
                  padding: "16px",
                }
          }
        >
          <div className="f-r-a-m-e">
            {!isDrawerOpen && (
              <Tooltip key={"toggle-sidebar-1"} title={"Toggle sidebar"} arrow>
                <div
                  className="drawer-button dropdown-button"
                  style={{
                    marginRight: "30px",
                  }}
                  onClick={toggleDrawer}
                >
                  <img
                    width="20"
                    height="20"
                    alt="Toggle sidebar"
                    src="/open-left-drawer.svg"
                  />
                </div>
              </Tooltip>
            )}

            <Tooltip
              key={"chat-private-tooltip-1"}
              title={"Your chat is private, secure, and only visible to you"}
              arrow
            >
              <img
                className="addy-check-security tooltip-1"
                width="18"
                height="16"
                src="/lock-icon-24.png"
              />
            </Tooltip>

            <div id="addy-header-assistant-select-parent">
              <Tooltip
                key={"assistant-tooltip-top"}
                title={"Select your assistant or create a new one"}
                arrow
              >
                <div
                  ref={assistantTopSelectRef}
                  className="button dropdown-button no-border-and-space-between"
                  id="addy-header-assistant-select"
                  onClick={() => {
                    setReferencedElementId(
                      "addy-header-assistant-select-parent"
                    );
                    setShowDropdown(true);
                  }}
                >
                  <div className="addy-assistant">
                    {selectedAssistant
                      ? selectedAssistant.appName.length > 17
                        ? `${selectedAssistant.appName.substring(0, 16)}...`
                        : selectedAssistant.appName
                      : "Loading..."}
                  </div>

                  {/* <img className="plus-icon" alt="" src="/plus.svg" /> */}
                  <img
                    className="expand-icon tooltip-2"
                    alt=""
                    src="/expand.svg"
                  />
                </div>
              </Tooltip>
            </div>

            {/* Show assistants drop down */}
            {showDropdown && (
              <div>
                <ChatAssistantDropDown2
                  displayPosition="bottom"
                  assistants={assistants}
                  hideAvatar={true}
                  selectedAssistant={selectedAssistant}
                  referencedElementId={referecedElementId}
                  defaultAssistant={defaultAssistant}
                  onAssistantClick={onAssistantClick}
                  updateDefaultAssistant={updateDefaultAssistant}
                  headerText="Agents"
                  createNewLink="https://app.addy-ai.com"
                  ref={dropdownRef}
                  marginRight={
                    referecedElementId === "addy-header-assistant-select"
                      ? "0px"
                      : ""
                  }
                />
              </div>
            )}
          </div>
          <div className="button-parent">
            {/* <Tooltip
                            key={"chat-history-tooltip"}
                            title={"Switch chats or create a new chat"}
                            arrow
                        >
                            <div
                                ref={chatHistoryInfoRef}
                                className="addy-chat-history-select-buton button dropdown-button no-border-and-space-between"
                                id="addy-chat-history-select"
                                onClick={onShowChatHistoryClick}
                            >
                                <div className="addy-assistant chat-history-name-text">
                                    {chatName === "sidebar.addy.so"
                                        ? "New chat"
                                        : chatName.length > 15
                                            ? `${chatName.substring(0, 12)}...`
                                            : chatName}
                                </div>
                                <img className="expand-icon" alt="" src="/expand.svg" />
                            </div>
                        </Tooltip> */}

            {clientID && (
              <div className="open-in-full-parent tooltip-3">
                {/* These images are being added
                                from the chrome extension
                                page to close and expand the sidebar chat */}
                {/* <img
                    className="open-in-full"
                    loading="lazy"
                    alt=""
                    src="/open-in-full.svg"/>
                    <img
                        className="close-icon"
                        loading="lazy"
                        alt=""
                        src="/close.svg"/> 
                */}
              </div>
            )}
          </div>
        </header>
        <ToastContainer />
      </div>

      {voiceMode && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            backgroundColor: "transparent",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "none",
          }}
        >
          <Box
            style={{
              pointerEvents: "auto",
              background: "transparent",
              padding: "20px",
              borderRadius: "12px",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <VoiceChat
              onSendButtonClick={onSendButtonClick}
              setVoiceMode={setVoiceMode}
              name={name}
              selectedText={""}
              compareMode={compareMode}
              selectedAssistant={selectedAssistant}
              uid={uid}
              hostName={hostName}
              CHAT_ID={CHAT_ID}
              clientHostname={clientHostname}
              selectedChatHistory={selectedChatHistory}
              email={email}
            />
          </Box>
        </Box>
      )}

      {showUpgrade && (
        <RequireUpgradeModal
          open={showUpgrade}
          onClose={() => setShowUpgrade(false)}
          uid={uid}
          organizationID={organizationId || ""}
        />
      )}
    </Box>
  );
};

export default Chat;
